/**
 * Created by renjie.huang on 2017/9/25.
 */

import React from 'react'
import config from './config/config'
import { Router, browserHistory } from 'react-router'
import { Button, ThemeProvider, Icon, Popover, Menu, Radio } from '@ucloud-fe/react-components'
import userService from './service/userService'
import queryString from 'query-string'
import route from './route'
import serviceUrl from './common/serviceUrl'
import localeService from './service/localeService'

// 动态加载所有 locale JSON 文件
const localeModules = {};
try {
  const ctx = require.context('./', false, /^\.\/\w+_\w+\.json$/);
  ctx.keys().forEach(key => {
    const name = key.replace('./', '').replace('.json', '');
    localeModules[name] = ctx(key);
  });
} catch(e) {
  // require.context 可能在某些环境不可用
}
import t2s from './common/traditionToSimple.js'
import cookie from './common/cookie'
import urls from './config/urls'
import darkTheme from '@ucloud-fe/react-components/lib/components/ThemeProvider/dark'
import lightTheme from '@ucloud-fe/react-components/lib/components/ThemeProvider/theme'
import { USiteWrapper } from 'common/stylecomponent'
import { switchDarkOn, switchAutoTheme, systemTheme, setAutoTheme } from './common/theme'
import Tooltip from '@ucloud-fe/react-components/lib/components/Tooltip';
import setTitle from './common/setTitle';
import lang from './common/lang';
import {isApplyCustomLayout, CustomHeaderLogo, CustomPageWrapper, CustomHeader} from './common/custom-layout'
import { restoreLastLoginEntry } from './common/loginEntry'
const channelTheme = process.env.channelTheme;

// 渠道主题
if (channelDesignTokens) {
  lightTheme.designTokens = channelDesignTokens;
}

function trackUrlChanged(url) {
  if(!window._paq) {
    return;
  }

  if (url) {
    window._paq.push(['setCustomUrl', url]);
    window._paq.push(['trackPageView']);
  }
}

/**
 * 处理版权文案中的年份：若标记年份或截止年份小于当前年份，则替换为当前年份
 * 例如 "Copyright © 2025" -> "Copyright © 2026"（当今年为 2026 时）
 * 例如 "Copyright © 2005-2025" -> "Copyright © 2005-2026"（仅更新截止年份）
 */
function normalizeCopyrightYear(text) {
  if (!text || typeof text !== 'string') return text || ''
  const currentYear = new Date().getFullYear()
  // 先处理年份区间 XXXX-YYYY，只将截止年份小于今年时替换为今年
  let result = text.replace(/(\d{4})-(\d{4})/g, (_, start, end) => {
    const endYear = parseInt(end, 10)
    if (endYear < currentYear) return `${start}-${currentYear}`
    return `${start}-${end}`
  })
  // 再处理单独出现的年份（不含区间中的起始年），若小于今年则替换为今年
  result = result.replace(/\b(19|20)\d{2}\b(?!-\d{4})/g, (match) => {
    const year = parseInt(match, 10)
    if (year < currentYear) return String(currentYear)
    return match
  })

  return result
}


// 专属云 SSO 登陆，强制跳转到 ‘/login‘ 页面,避免触发 170 重定向到登陆页面
(function () {
  // 专属云 SSO 登陆，强制跳转到 ‘/login‘ 页面
  // 专属云 SSO 登陆标识请配置 oauthProvider 和 oauthUrl , [isOAuthByBJCA,isOAuthByST]是历史配置，不推荐使用
  if (!APP_CONFIG.isOAuthByBJCA && !APP_CONFIG.isOAuthByST && !APP_CONFIG.oauthProvider) return
  userService.getUserInfo = function (...args) {
    return Promise.resolve({})
  };
  const oauthUrl = APP_CONFIG.oauthUrl ? APP_CONFIG.oauthUrl : `/OAuth/default`;
  if([oauthUrl, '/OAuth/bjca', '/OAuth/sensetime', '/login'].includes(location.pathname)) return
  // 非标： 179 渠道支持激活子账号
  if (location.pathname.endsWith('/activeSubaccount') && APP_CONFIG.channelId === 179) return
  window.location.href = '/login'
})()

class App extends React.Component {
  constructor(props) {
    super(props)
    var self = this
    self.service = config.default
    self.cid = ''
    var query = queryString.parse(document.location.search)
    try {
      self.service = serviceUrl(query['service']) || self.service
      self.cid = query['cid'] ? decodeURIComponent(query['cid']) : self.cid
    } catch (e) {
      console.error(e)
    }

    this.getLocale()
    const isAutoThemeOn = cookie.getCookie('is_auto_theme_on') == 1 ? true : false
    if (isAutoThemeOn) {
      setAutoTheme()
    }
    const theme = (APP_CONFIG.isDefaultDarkTheme || cookie.getCookie('is_dark_theme_on') == 1) ? darkTheme : lightTheme
    self.state = { theme: theme, pathname: location.pathname }
    self.isSupportPrefersColorScheme = systemTheme() ? true : false
  }

  getLocale() {
    const localeKey = lang.getLocaleKey(lang.getLang('CN_lang'));
    const defaultLocaleKey = lang.getLocaleKey(lang.getDefaultLanguage().key);
    let url;
    if (window.location.host.indexOf('localhost') == 0) {
      url = `/dev/locale/${localeKey}.json`;
    } else {
      url = localeModules[localeKey] || localeModules[defaultLocaleKey];
    }

    fetch(url)
      .then((res) => {
        return res.json()
      })
      .then((data) => {
        if (lang.getLang('CN_lang') === 'zh_TW') {
          Object.keys(data).forEach((key) => {
            let item = data[key]
            Object.keys(t2s.Words).forEach(function (key) {
              if (item.indexOf(key) >= 0) {
                item = item.replace(new RegExp(key, 'g'), t2s.Words[key])
              }
            })
            data[key] = t2s.Traditionalized(item)
          })
        }

        localeService.setTranslate(data)
        this.forceUpdate()
      })
      .catch((e) => {
        console.log('获取语言文件出错', e.message)
      })
  }

  afterLoginSuperBrow() {
    let messege = {
      action: 'ucloudLogin',
      params: {
        login: true,
      },
    }
    return chrome.runtime.sendMessage(this.cid, messege)
  }

  componentDidMount() {
    let self = this
    // 仅在浏览器首次进入主登录页时恢复上次成功登录使用的入口。
    // SPA 内从子账号页主动切换到主账号页时不会触发这里，仍可正常切换。
    if (restoreLastLoginEntry()) {
      return
    }
    browserHistory.listenBefore(function (location, callback) {
      trackUrlChanged(location.pathname + location.search);
      self.setState({ pathname: location.pathname })
      callback()
    })

    if(APP_CONFIG.isDefaultDarkTheme) {
      cookie.setCookie('is_dark_theme_on', "1")
      this.setState({ theme: darkTheme })
    } else {
      cookie.setCookie('is_dark_theme_on', "0")
      this.setState({ theme: lightTheme })
    }
    var pathname = document.location.pathname
    if (pathname === '/logout' || pathname === '/guide') {
      return
    }

    userService
      .getUserInfo()
      .then(function (data) {
        if (data.length && data[0].UserId) {
          if (self.cid) {
            return self.afterLoginSuperBrow()
          }
          window.open(self.service, '_self')
        }
      })
      .catch(function (data) {})
  }

  setCnLang(_lang, CN_lang) {
    lang.setLang(_lang, CN_lang);
  }

  getThemeOn = () => {
    const darkThemeOn = cookie.getCookie('is_dark_theme_on') == 1 ? true : false
    const autoThemeOn = cookie.getCookie('is_auto_theme_on') == 1 ? true : false
    return {
      darkThemeOn,
      autoThemeOn,
    }
  }
  switchTheme = async (type) => {
    if (type === 'off') {
      switchDarkOn(false)
      switchAutoTheme(false)
    } else if (type === 'on') {
      switchDarkOn(true)
      switchAutoTheme(false)
    } else if (type === 'auto') {
      switchAutoTheme(true)
    }
    const theme = cookie.getCookie('is_dark_theme_on') == 1 ? darkTheme : lightTheme
    this.setState({ theme })
  }

  buildLogo = () => {
    if(isApplyCustomLayout) {
      const { pathname } = this.state;
      return <CustomHeaderLogo pathname={pathname} />;
    }
  

    if (APP_CONFIG.LOGO_IMG_URL) {
      return (
        <div className="logo-wrapper" style={{overflow: 'visible'}}>
          <a
            href={urls.LOGOURL}
            target="/blank"
            style={{display: 'block', height: `${APP_CONFIG.logoHeight || 34}px`}}
          >
            <img style={{height: '100%'}} src={APP_CONFIG.LOGO_IMG_URL} alt="logo" />
          </a>
        </div>
      );
    }

    return (
      <div className="logo-wrapper">
        <a
          href={urls.LOGOURL}
          target="/blank"
          className="u-logo"
          style={{
            width: APP_CONFIG.logoWidth,
            height: APP_CONFIG.logoHeight,
            backgroundSize:
              APP_CONFIG.logoWidth && APP_CONFIG.logoHeight
                ? `${APP_CONFIG.logoWidth}px ${APP_CONFIG.logoHeight}px`
                : undefined,
          }}
        />
      </div>
    )
  }

  render() {
    let getTranslate = localeService.getTranslate
    const { darkThemeOn, autoThemeOn } = this.getThemeOn()
    const { theme, pathname} = this.state;
    const languages = lang.getLanguages();

    setTitle('LOGIN54');
    if (pathname === '/guide') {
      return (
        <ThemeProvider theme={theme}>
          <USiteWrapper>
            <Router history={browserHistory} routes={route} />
          </USiteWrapper>
        </ThemeProvider>
      )
    }
    return (
      <ThemeProvider theme={theme}>
        <CustomPageWrapper pathname={pathname}>
        <USiteWrapper className="u-site-wrapper">
          {!APP_CONFIG.isHideHeader && (
            <CustomHeader>
            <div className="u-header">
              <div className="u-header-main">
                {this.buildLogo()}
                <div className="u-header-right">
                  <div className="t2s">
                    {!channelTheme && !APP_CONFIG.isHideThemeSwitch && !channelDesignTokens ? (
                      <span className="u-pr16">
                        <Popover
                          popup={
                            <Menu style={{ width: 220 }}>
                              <Menu.Item>
                                <Radio
                                  checked={!darkThemeOn && !autoThemeOn}
                                  onChange={() => {
                                    this.switchTheme('off')
                                  }}
                                >
                                  <span>{getTranslate('THEME_LIGHT')}</span>
                                </Radio>
                              </Menu.Item>
                              <Menu.Item>
                                <Radio
                                  checked={!!darkThemeOn && !autoThemeOn}
                                  onChange={() => {
                                    this.switchTheme('on')
                                  }}
                                >
                                  <span>{getTranslate('THEME_DARK')}</span>
                                </Radio>
                              </Menu.Item>
                              <Menu.Item>
                                <Radio
                                  checked={!!autoThemeOn}
                                  onChange={() => {
                                    this.switchTheme('auto')
                                  }}
                                  disabled={!this.isSupportPrefersColorScheme}
                                >
                                  {!this.isSupportPrefersColorScheme ? (
                                    <Tooltip
                                      popup={getTranslate('THEME_DISABLED')}
                                      arrow={false}
                                      getPopupContainer={() => document.body}
                                    >
                                      <span>{getTranslate('THEME_AUTO')}</span>
                                    </Tooltip>
                                  ) : (
                                    <span>{getTranslate('THEME_AUTO')}</span>
                                  )}
                                  <Tooltip
                                    getPopupContainer={() => document.body}
                                    placement="bottomLeft"
                                    arrow={false}
                                    popup={
                                      <div style={{ width: 170, wordBreak: 'break-all' }}>
                                        {getTranslate('THEME004')}
                                      </div>
                                    }
                                  >
                                    <Icon type="circle-question" className="u-blue" />
                                  </Tooltip>
                                </Radio>
                              </Menu.Item>
                            </Menu>
                          }
                        >
                          <Icon type="dark"></Icon>
                        </Popover>
                      </span>
                    ) : null}
                    {!APP_CONFIG.isHideLangSwitch && languages.length > 1 && (
                      <span>
                        {languages.map((item, index) => (
                          <React.Fragment key={item.key}>
                            {index > 0 && <span className="u-pl6 u-pr6">/</span>}
                            <span
                              onClick={() => {
                                this.setCnLang(item._lang, item.key)
                              }}
                              className={
                                lang.getLang('CN_lang') === item.key ? 'current' : null
                              }
                            >
                              {item.label}
                            </span>
                          </React.Fragment>
                        ))}
                      </span>
                    )}
                  </div>
                  {!APP_CONFIG.isHideTopHelp && (
                    <a href={urls.URL003} target="/blank">
                      {getTranslate('TOP_HELP')}
                    </a>
                  )}
                  {!APP_CONFIG.isHideTopBackToIndex && (
                    <Button
                      size="lg"
                      styleType="primary"
                      onClick={() => {
                        lang.isEnglishLikeLanguage(lang.getLang('CN_lang'))
                          ? (window.location = urls.URL006)
                          : (window.location = urls.URL004)
                      }}
                    >
                      {getTranslate('TOP_BACKTOINDEX')}
                    </Button>
                  )}
                </div>
              </div>
            </div>
            </CustomHeader>
          )}

          <div className="u-content">
            <Router
              history={browserHistory}
              routes={route}
              onUpdate={() => {
                var pathname = document.location.pathname
                if (pathname === '/guide') {
                  this.forceUpdate()
                }
              }}
            />
          </div>

          <div className="copyright">{normalizeCopyrightYear(APP_CONFIG.COPYRIGHT || getTranslate('COYPRIGHT'))}</div>
        </USiteWrapper>
        </CustomPageWrapper>
      </ThemeProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.jsx